import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

const urls = {
  createEvent: 'event',
  uploadImage: 'event/uploadImage',
  getAllEvent: 'event/getAllEventByInterest',
  updateEventStatus: 'event/updateEventStatus',
  deleteEvent: 'event/deleteEvent',
  getEventById: 'event/getEventById',
  updateEvent: 'event/updateEvent'
};

export const getAllEventApi = createAsyncThunk('serviceplug/getAllEvent', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.getAllEvent);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const uploadImageApi = createAsyncThunk('serviceplug/uploadImage', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.uploadImage}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const createEventApi = createAsyncThunk('serviceplug/createEvent', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createEvent}`,
      method: 'post',
      data: params
    });
    const data = await response.data?.result;

    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const updateEventStatusApi = createAsyncThunk('serviceplug/updateEventStatus', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateEventStatus}`,
      method: 'post',
      data: params
    });
    const data = await response.data?.result;
    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const deleteEventApi = createAsyncThunk('serviceplug/deleteEvent', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.deleteEvent}`,
      method: 'delete',
      data: params
    });
    const data = await response.data;

    return data;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const getEventByIdApi = createAsyncThunk('serviceplug/getEventById', async (params, thunkApi) => {
  try {
    const response = await axios.get(`${urls.getEventById}`, { params });
    if (!_.isEmpty(response.data?.result)) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const updateEventApi = createAsyncThunk('serviceplug/updateEvent', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.updateEvent}/${params._id}`,
      method: 'put',
      data: params
    });
    const data = await response.data;

    return data?.result;
  } catch (err) {
    // thunkApi.dispatch(showMessage({ message: 'Something went wrong. please try again!', variant: 'error' }));
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});
